import {
  types,
  actions
} from 'reducers/config';
import {
  call,
  put,
  takeLatest
} from 'redux-saga/effects';
import * as api from 'services/api';

function* fetchConfig() {
  try {
    const response = yield call(api.fetchConfig);
    yield put(actions.success(response));
  } catch (error) {
    yield put(actions.failure(error));
  }
}

export default function* rootSaga() {
  yield takeLatest(types.CONFIG_REQUEST, fetchConfig);
}



// WEBPACK FOOTER //
// ./src/sagas/config.js